import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Siren from '../../../assets/images/siren.png';
import './error.less';


export default class ErrorBoundary extends Component {
    constructor( props ) {
        super( props );
        const { error } = props;

        switch ( error ) {
            case 'path':
                this.state = {
                    hasError: true,
                    errorText: 'Invalid URL. Please check your URL and try again.'
                };
                break;
            default:
                this.state = {
                    hasError: !!props.error,
                    errorText: props.error ? props.error : ''
                };
                break;
        }
    }

    componentDidCatch( error, info ) {
        this.setState(
            {
                hasError: true,
                errorText: `${ error } ${ info.componentStack }`
            }
        );

    }

    render() {
        const { hasError, errorText } = this.state;

        if ( hasError ) {
            return (
                <div className="error-page">
                    <div className="error-container">
                        <img alt='Error' src={ Siren } />
                        <h1>Uh-oh!</h1>
                        <h3>We seem to be having difficulties</h3>
                        <h5>{ errorText }</h5>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.oneOfType( [
        PropTypes.arrayOf( PropTypes.node ),
        PropTypes.node
    ] )
};